// List of Micro services api endpoint URL/PORT

const servicesList = {
    'ACCOUNTS' : {
        LOCAL_URL: 'http://localhost:3005', 
        SANDBOX_URL: 'https://logmaster.shop',
        // SANDBOX_URL: 'http://localhost:3005',
        STAGING_URL : 'https://staging-api.logmaster.nz',
        PRODUCTION_URL : 'https://prod-api.logmaster.nz',
        PORT: null,
        description: 'Logmaster Accounts.',
    }
}

export { servicesList }; 